"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  sk: {
    dialog: {
      confirm: 'ok',
      cancel: 'cancel'
    },
    tabletoolbar: {
      search: 'search',
      "delete": 'delete'
    }
  }
};
exports["default"] = _default;